import React, { useEffect, useState } from 'react';
import './ScheduleDemoTab.pcss';
import { StoreState } from '@mm/state/store-interfaces';
import { activeCompanySelector } from '@mm/state/selectors/viewSelectors';
import { useDispatch, useSelector } from 'react-redux';
import { Dispatch } from 'redux';
import modalActions from '@mm/state/modules/modalsState/actions';
import usersCRUDActions from '@mm/state/actions/UsersCRUDActions';
import moment from 'moment';
import { setRequestDemoSnoozeDateActionCreator } from '@mm/state/actions/viewActions';
import companyCRUDActions from '@mm/state/actions/CompanyCRUDActions';

const useSnoozeTab = () => {
  const requestDemoSnoozeDate = useSelector(
    (state: StoreState) => state.view.requestDemoSnoozeDate,
  );

  if (requestDemoSnoozeDate) {
    const momentDate = moment(requestDemoSnoozeDate);
    return momentDate && momentDate.isValid() && moment().isBefore(momentDate);
  }

  return false;
};

export const ScheduleDemoTab = () => {
  const activeCompany = useSelector(activeCompanySelector);
  const session = useSelector((state: StoreState) => state.session.session);
  const dispatch: Dispatch<StoreState> = useDispatch();
  const snoozeTab = useSnoozeTab();

  const [isMobile, setIsMobile] = useState(false);

  const getInnerWidth = () => window.innerWidth <= 760;

  useEffect(() => {
    window.addEventListener('resize', onResize);
    setIsMobile(getInnerWidth());
    if (activeCompany && session && !session?.isGuest) {
      dispatch(companyCRUDActions.getByCompany(activeCompany));
    }
    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, [activeCompany]);

  const onResize = () => {
    setIsMobile(getInnerWidth());
  };

  const openDemoModal = () => {
    if (activeCompany && session) {
      const emails = activeCompany.businessEmail
        ? `${activeCompany.businessEmail}/${session.email}`
        : `${session.email}`;
      const messageText = `
        Ready to chat? Someone from our Sales team will email you
        at ${emails}.
      `;

      const onCloseHandler = async (ok: boolean) => {
        if (ok) {
          await dispatch(usersCRUDActions.requestDemo(activeCompany.id));
          dispatch(companyCRUDActions.getByCompany(activeCompany));
          dispatch(
            modalActions.openGeneralTextModal({
              header: '',
              message: 'Great! Someone will be in touch shortly.',
            }),
          );
        } else {
          const snoozeDate = moment().add(1, 'minute').toISOString();
          dispatch(
            modalActions.openGeneralTextModal({
              header: '',
              message:
                'Ok, email us at sales@mobilemonkey.com when you’re ready!',
            }),
          );
          dispatch(setRequestDemoSnoozeDateActionCreator(snoozeDate));
        }
      };

      dispatch(
        modalActions.openGeneralConfirmModal({
          headerText: '',
          messageText,
          okButtonStyling: { blue: true },
          cancelButtonFirst: true,
          cancelButtonText: 'Not Now',
          onCloseHandler,
        }),
      );
    }
  };

  if (
    activeCompany &&
    activeCompany.consideredDemo &&
    !snoozeTab &&
    !isMobile
  ) {
    return (
      <div className="schedule-demo-tab" onClick={openDemoModal}>
        <div className="schedule-demo-tab__tab">Schedule Demo</div>
      </div>
    );
  }

  return null;
};
